import { CardInputsContainer } from "~/common/components";
import { CONSULTATION_TYPES } from "~/common/utils";
import { useCurrentTeamMemberContext } from "~/providers/hooks";
import { useListSupplementalForms } from "~/providers/hooks/useListSupplementalForms";
import { SupplementalQuestionsEditor } from "./SupplementalQuestionsEditor";

export const SupplementalQuestions = () => {
  const teamMember = useCurrentTeamMemberContext();
  const organizationId =
    teamMember.organization_team_members[0].organization.id;
  const { data: supplementalForms } = useListSupplementalForms(organizationId);

  if (!supplementalForms) return;

  const { screening, intake } = supplementalForms;

  return (
    <CardInputsContainer title="Supplemental questions">
      <div className="flex flex-col gap-6">
        <SupplementalQuestionsEditor
          questions={screening}
          type={CONSULTATION_TYPES.screening}
        />

        <div className="border-b border-neutral-700" />

        <SupplementalQuestionsEditor
          questions={intake}
          type={CONSULTATION_TYPES.intake}
        />
      </div>
    </CardInputsContainer>
  );
};
